import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { CompanySwitchStrategy } from '@core/http-legacy';
import { TellentCurrentUserSelectors } from '@core/tellent-data';
import { AppKind, injectTellentAppKind } from '@core/tellent-types';
import { injectTellentAppUrlOpener } from '@core/tellent-util';
import { writeOrgGuidToLocalStorage } from '@tellent-client/auth-logic';

@Injectable({ providedIn: 'root' })
export class TellentClientCompanySwitchStrategy implements CompanySwitchStrategy {
  private readonly store = inject(Store);
  public open = injectTellentAppUrlOpener();
  public appKind = injectTellentAppKind();

  private currentOrgUser = this.store.selectSignal(TellentCurrentUserSelectors.data);

  public switchCompany(orgGuid: string) {
    const kind = this.resolvePreferredAppKind(orgGuid);
    writeOrgGuidToLocalStorage(this.currentOrgUser()?.guid!, kind);
    this.open(kind, undefined, orgGuid);
  }

  private resolvePreferredAppKind(orgGuid: string) {
    const member = this.currentOrgUser()?.members.find(member => member.orgGuid === orgGuid);

    return (
      member?.seats.find(seat => seat.app.kind === <unknown>this.appKind)?.app.kind ??
      member?.seats[0]?.app.kind ??
      AppKind.TellentAdmin
    );
  }
}
